

/* tslint:disable */




import { FlowchartComponentDto } from './FlowchartComponentDto';
import { FlowchartElementType } from './FlowchartElementType';
import { GuidelineCriterionDto } from './GuidelineCriterionDto';
import { GuidelineObservationDto } from './GuidelineObservationDto';

export class FlowchartDecisionNodeDto extends FlowchartComponentDto {
    guidelineCriteriaId?: string | null;
    guidelineCriteria?: GuidelineCriterionDto;
    guidelineObservationId?: string | null;
    guidelineObservation?: GuidelineObservationDto;
    rule?: string;
    rulePrettyfied?: string;
    ruleTitle?: string;
    ruleDescription?: string;
    elementType?: FlowchartElementType;

}

